export enum ProductType {
  GUARD = "Guard",
  PROTECT = "Protect",
  GUARDIAN = "Guardian",
  PROTECT_PLUS = "Protect Plus",
  PROTECTOR = "Protector",
}
